import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-default",
    templateUrl: "./default.component.html",
    styleUrls: ["./default.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DefaultComponent implements OnInit {
  constructor() {
    // This is intentional
  }

  ngOnInit() {
    // This is intentional
  }
}
